import React from "react";
import Header from "../componants/header/Header";
import Footer from "../componants/Footer";
import { Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import Loader from "../componants/loader/Loader";

const Layout = () => {

  const isLoader = useSelector((state) => state.layout.isLoader);

  return (
    <div>
      <Loader isLoader={isLoader} />
      <Header />
      <Outlet />
      <Footer />
    </div>
  );
};

export default Layout;
